import { NumericFormat } from 'react-number-format';
import { formatCurrency } from '../../../../../../../ui/src';
import { DrawApi } from '@apply/api';

interface IEquityRequirementProps {
    onEquityRequirementChange: (newValue: number) => void;
    drawBudget?: DrawApi.IDrawBudget;
    isAdmin: boolean;
}

export const EquityRequirement = ({ drawBudget, isAdmin, onEquityRequirementChange }: IEquityRequirementProps): JSX.Element => {
    return (
        <div>
            <label htmlFor='equityRequirement'>Equity Requirement</label>
            {isAdmin ? (
                <NumericFormat
                    className='draw-header-input'
                    value={drawBudget?.equityRequirement}
                    placeholder={'$ 0'}
                    thousandSeparator={true}
                    prefix={'$ '}
                    onValueChange={(values) => onEquityRequirementChange(parseInt(values.value))}
                />
            ) : (
                <p>{drawBudget?.equityRequirement ? formatCurrency(drawBudget?.equityRequirement, 0) : '-'}</p>
            )}
        </div>
    );
};
